<nb-layout>
  <nb-layout-column>
    <div class="public-shared-container">
      <nb-card>
        <nb-card-body>
          <div class="shaed-files">
            <h2 class="sub-title">
             File Preview
            </h2>

            <div class="file-preview-container">
              <div class="document-preview" *ngIf="type === 'DOCUMENT'">
                <pdf-viewer
                  [src]="pdfSource"
                  [rotation]="0"
                  [original-size]="false"
                  [show-all]="true"
                  [fit-to-page]="false"
                  [zoom]="0.75"
                  [zoom-scale]="'page-width'"
                  [stick-to-page]="false"
                  [render-text]="true"
                  [external-link-target]="'blank'"
                  [autoresize]="true"
                  [show-borders]="false"
                  style="width: 100%; height: 600px"
                ></pdf-viewer>
              </div>

              <div class="picture-preview" *ngIf="type == 'PHOTO'">
                <img class="img-fluid picture" [src]="photoStreamFile" />
              </div>

              <div
                id="video-player"
                class="video-preview"
                *ngIf="type === 'VIDEO' && isPreviewFileExist"
              >
                <vg-player>
                  <vg-overlay-play></vg-overlay-play>
                  <vg-buffering></vg-buffering>

                  <vg-scrub-bar [vgSlider]="true">
                    <vg-scrub-bar-current-time
                      [vgSlider]="false"
                    ></vg-scrub-bar-current-time>
                    <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                  </vg-scrub-bar>

                  <vg-controls
                    vgFor="myMedia"
                    [vgAutohide]="false"
                    [vgAutohideTime]="5"
                  >
                    <vg-play-pause vgFor="myMedia"></vg-play-pause>
                    <vg-time-display
                      vgProperty="current"
                      vgFormat="hh:mm:ss"
                    ></vg-time-display>
                    <div class="time-separator">/</div>
                    <vg-time-display
                      vgProperty="total"
                      vgFormat="hh:mm:ss"
                    ></vg-time-display>

                    <vg-scrub-bar style="pointer-events: none"></vg-scrub-bar>
                    <vg-mute></vg-mute>
                    <vg-volume></vg-volume>
                    <vg-fullscreen></vg-fullscreen>
                  </vg-controls>

                  <video
                    #myMedia
                    [vgMedia]="$any(myMedia)"
                    [vgMaster]="true"
                    id="myMedia"
                    preload="auto"
                    crossorigin
                  >
                    <source [src]="videoStreamingUrl" type="video/mp4" />
                  </video>
                </vg-player>
              </div>

              <div
                id="audio-player"
                class="audio-preview"
                *ngIf="type === 'AUDIO' && isPreviewFileExist"
              >
                <vg-player>
                  <vg-controls>
                    <vg-play-pause></vg-play-pause>
                    <vg-time-display
                      vgProperty="current"
                      vgFormat="hh:mm:ss"
                    ></vg-time-display>
                    <div class="time-separator">/</div>
                    <vg-time-display
                      vgProperty="total"
                      vgFormat="hh:mm:ss"
                    ></vg-time-display>
                    <vg-buffering></vg-buffering>

                    <vg-scrub-bar>
                      <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
                      <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
                    </vg-scrub-bar>
                    <vg-mute></vg-mute>
                    <vg-volume></vg-volume>
                  </vg-controls>
                  <audio
                    #myMedia
                    [vgMedia]="myMedia"
                    [vgMaster]="true"
                    id="my-audio"
                    autoplay="false"
                    preload="auto"
                    crossorigin
                  >
                    <source [src]="audioStreamingUrl" type="audio/mp3" />
                  </audio>
                </vg-player>
              </div>
              <div
                class="alert-box-custom"
                *ngIf="
                  (!type) ||
                  (!isPreviewFileExist && isPreviewFileExist !== null)
                "
              >
                <div class="alert-box-content">
                  <i class="fa-solid fa-message-exclamation"></i>
                  <div class="message">
                    <span class="text">
                      Unable to preview file! Please download the file to preview.
                    </span>
                  </div>
                </div>
              </div>

              <div
                class="alert-box-custom"
                *ngIf="!isMasterFileExist && isMasterFileExist !== null"
              >
                <div class="alert-box-content">
                  <i class="fa-solid fa-message-exclamation"></i>
                  <div class="message">
                    <span class="text">
                      Unable to retrieve the file! The system cannot find the file in the specified storage location.
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="buttons-row row">
              <div class="col-lg-12">
                <button
                  nbButton
                  matRipple
                  hero
                  status="info"
                  type="button"
                  (click)="back()"
                >
                  <nb-icon icon="arrow-ios-back-outline"></nb-icon>
                  Back
                </button>
              </div>
            </div>
          </div>
        </nb-card-body>
      </nb-card>
    </div>
  </nb-layout-column>
</nb-layout>

<loading *ngIf="loading" message="{{ loadingMessage }}"></loading>
